const basePath = '/3d-stock';

export class StockPath {
  static index() {
    return basePath;
  }

  static show() {
    return basePath;
  }

  static products() {
    return `${basePath}/products`;
  }

  static lifestyles() {
    return `${basePath}/lifestyles`;
  }

  static materials() {
    return `${basePath}/materials`;
  }

  static newProducts() {
    return `${basePath}/new-products?indexPage=true`;
  }

  static newLifestyles() {
    return `${basePath}/new-lifestyles?indexPage=true`;
  }

  static newMaterials() {
    return `${basePath}/new-materials?indexPage=true`;
  }

  static newProductsPure() {
    return `${basePath}/new-products`;
  }

  static editProducts() {
    return `${basePath}/edit-products`;
  }

  static editLifestyles() {
    return `${basePath}/edit-lifestyles`;
  }

  static editMaterials() {
    return `${basePath}/edit-materials`;
  }

  static newLifestylesPure() {
    return `${basePath}/new-lifestyles`;
  }

  static newMaterialsPure() {
    return `${basePath}/new-materials`;
  }
}
